import { SVGProps } from 'react'

interface ProfileCopyIconProps extends SVGProps<SVGSVGElement> {
  size?: number
}
export const ProfileCopyIcon = ({
  size = 16,
  ...props
}: ProfileCopyIconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path
          d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
          stroke="white"
          strokeOpacity="0.7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.33301 10.0007H2.66634C2.31272 10.0007 1.97358 9.86018 1.72353 9.61013C1.47348 9.36008 1.33301 9.02094 1.33301 8.66732V2.66732C1.33301 2.3137 1.47348 1.97456 1.72353 1.72451C1.97358 1.47446 2.31272 1.33398 2.66634 1.33398H8.66634C9.01996 1.33398 9.3591 1.47446 9.60915 1.72451C9.8592 1.97456 9.99967 2.3137 9.99967 2.66732V3.33398"
          stroke="white"
          strokeOpacity="0.7"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  )
}
